import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface BrushWordmarkProps {
    text?: string
    color?: string
    className?: string
    rough?: boolean
}

// The BLUNTSHEEP wordmark with a dry-brush, photocopied edge. Decorative only.
const BrushWordmark: FC<BrushWordmarkProps> = ({ text = 'BLUNTSHEEP', color = '#0D0D0D', className, rough = true }): ReactNode => {
    const id = `brush-${useId().replace(/:/g, '')}`

    return (
        <svg viewBox='0 0 1000 170' className={cn('block h-auto w-full overflow-visible', className)} aria-hidden='true'>
            {rough && (
                <defs>
                    <filter id={id} x='-4%' y='-25%' width='108%' height='150%'>
                        <feTurbulence type='fractalNoise' baseFrequency='0.03 0.08' numOctaves='2' seed='7' result='warp' />
                        <feDisplacementMap in='SourceGraphic' in2='warp' scale='10' xChannelSelector='R' yChannelSelector='G' result='warped' />
                        <feTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='1' seed='4' result='grain' />
                        <feColorMatrix in='grain' type='matrix' values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -7 5.2' result='holes' />
                        <feComposite in='warped' in2='holes' operator='in' />
                    </filter>
                </defs>
            )}

            <text
                x='500'
                y='140'
                textAnchor='middle'
                textLength='980'
                lengthAdjust='spacingAndGlyphs'
                fill={color}
                fontSize='176'
                fontWeight='900'
                filter={rough ? `url(#${id})` : undefined}
                style={{
                    fontFamily: 'var(--font-app-heading, var(--font-app-sans, ui-sans-serif, system-ui, sans-serif))',
                    letterSpacing: '-0.04em'
                }}
            >
                {text}
            </text>
        </svg>
    )
}

export default BrushWordmark
